/**
 * Feature flags for the FrontDesko admin frontend.
 *
 * Flip a flag to true only after the backing operational readiness is
 * complete (env vars set, ops rota in place, customer comms / TOS done,
 * pilot hotels selected). See PR #199 functional review for the
 * readiness checklist.
 *
 * Toggle via REACT_APP_* env vars at build time; otherwise the hardcoded
 * default applies.
 */

// Referrals program: $37 conversion credit + $25 cash payout.
// Backend endpoints exist on production but are gated here pending:
//   - REFERRAL_PAYOUT_SECRET set in prod env
//   - DISCORD_REFERRAL_PAYOUT_WEBHOOK set in prod env
//   - Tax / TOS sign-off (TDS, 1099 thresholds)
//   - Discord watcher rota for manual payouts
export const REFERRALS_ENABLED =
  process.env.REACT_APP_REFERRALS_ENABLED === 'true';
